(function uiSideNavModuleDefinition() {
    'use strict';

    angular.module('UiSideNav', [])
        .directive('uiSideNav', ['$translate', '$http', '$state', 'auth', 'errorsExtend', 'config',
            function ($translate, $http, $state, auth, errors, config) {
                return {
                    restrict: 'E',
                    templateUrl: '/app/directives/ui-side-nav/ui-side-nav.html',
                    scope: {
                        urlIcon: '=',
                        appName: '=',
                        actions: '=',
                        tools: '='
                    },
                    controller: [
                        '$scope', '$element', function ($scope, $element) {
                            $scope.init = function () {
                                $scope.releaseName = config.releaseName();
                                $scope.logoSrc = 'app/views/inicio/LogoEdrMenu.png';
                            };

                            $scope.getAssemblyVersion = function () {
                                $http({
                                    method: 'GET',
                                    url: 'Home/GetVersion'
                                }).then(function successCallback(response) {
                                    $scope.assemblyVersion = response.data;
                                }, function errorCallback(response) {
                                    // or server returns response with an error status.
                                });
                            }

                            $scope.goTo = function (link) {

                                if (link.function) {
                                    eval('$scope.' + link.function)();
                                } else if (link.state) {
                                    $state.go(link.state);
                                }
                            };

                            $scope.createCORSRequest = function () {
                                auth.createTokenChangeApp().then(function (result) {
                                    window.location = config.custom('cppUrl') + "/#/?t=" + result.token;
                                },
                                    function (error) {
                                        errors.showError(error);
                                    });

                            }

                            $scope.getAssemblyVersion();

                            $scope.init();
                        }]
                };
            }
        ]);
})();